var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 7.5L7.50049 12.5C7.23784 12.5 6.97777 12.4483 6.73512 12.3478C6.49247 12.2472 6.27199 12.0999 6.08628 11.9142C5.90056 11.7285 5.75324 11.508 5.65273 11.2654C5.55222 11.0227 5.50049 10.7626 5.50049 10.5V9H1.63327C1.49148 9 1.3513 8.96985 1.22205 8.91154C1.0928 8.85323 0.977432 8.7681 0.883593 8.6618C0.789753 8.5555 0.719593 8.43046 0.677767 8.29498C0.635941 8.15949 0.623406 8.01666 0.640993 7.87597L1.39099 1.87597C1.42122 1.63411 1.53875 1.41163 1.72147 1.25032C1.90419 1.08902 2.13954 1 2.38327 1H10.0005M13.0005 7.5H10.0005V1H13.0005C13.1331 1 13.2603 1.05268 13.354 1.14645C13.4478 1.24021 13.5005 1.36739 13.5005 1.5V7C13.5005 7.13261 13.4478 7.25979 13.354 7.35355C13.2603 7.44732 13.1331 7.5 13.0005 7.5V7.5Z",
    stroke: "#679CF6",
    strokeWidth: 0.969231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.f16a50194ed6015b1ad4365ea57b6720.svg";
export { ForwardRef as ReactComponent };